import { AddCoTeacherCombinedProps } from './types';

const usePresenter = (props: AddCoTeacherCombinedProps): AddCoTeacherCombinedProps => {
  return props;
};

export default usePresenter;
